import { LangSelect } from "./lang-select";

export function Language() {
  return (
    <div className="space-y-4">
      <LangSelect />
    </div>
  );
}
